export const DOMESTIC_CHANNEL_TYPES = {
  JIO_EVA: 'Channel::JioEva',
  SMARTFLO: 'Channel::Smartflo',
};

export const SMARTFLO_LOGO_PATH =
  '/assets/images/dashboard/channels/smartflo.png';

export const TWILIO_LOGO_PATH =
  '/assets/images/dashboard/channels/twilio.png';

export function isDomesticChannelType(channelType) {
  return Object.values(DOMESTIC_CHANNEL_TYPES).includes(channelType);
}

export function isJioEvaChannel(channelType) {
  return channelType === DOMESTIC_CHANNEL_TYPES.JIO_EVA;
}

export function isSmartfloChannel(channelType) {
  return channelType === DOMESTIC_CHANNEL_TYPES.SMARTFLO;
}

export function domesticProviderShortLabel(channelType) {
  if (isSmartfloChannel(channelType)) return 'Tata';
  if (isJioEvaChannel(channelType)) return 'Jio';
  return 'Call';
}

export function domesticCallButtonClass(channelType) {
  if (isSmartfloChannel(channelType)) return 'domestic-call--smartflo';
  if (isJioEvaChannel(channelType)) return 'domestic-call--jio';
  return '';
}

export function domesticProviderLabel(channelType) {
  if (isSmartfloChannel(channelType)) return 'Tata';
  if (isJioEvaChannel(channelType)) return 'Jio';
  return 'Call';
}

export function groupDomesticInboxesByProvider(inboxes = []) {
  const groups = [
    { key: DOMESTIC_CHANNEL_TYPES.SMARTFLO, label: 'Tata', inboxes: [] },
    { key: DOMESTIC_CHANNEL_TYPES.JIO_EVA, label: 'Jio', inboxes: [] },
  ];

  inboxes.forEach(inbox => {
    const channelType = inbox.inboxObject?.channel_type || inbox.channel_type;
    const group = groups.find(item => item.key === channelType);
    if (group) {
      group.inboxes.push(inbox);
    }
  });

  return groups.filter(group => group.inboxes.length > 0);
}

export function formatDomesticPhoneNumber(phone) {
  if (!phone) return '';

  const digits = String(phone).replace(/\D/g, '');
  if (!digits) return phone;

  if (digits.length === 10) {
    return `+91 ${digits.slice(0, 5)} ${digits.slice(5)}`;
  }

  if (digits.length === 12 && digits.startsWith('91')) {
    const local = digits.slice(2);
    return `+91 ${local.slice(0, 5)} ${local.slice(5)}`;
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
  }

  return phone.startsWith('+') ? phone : `+${digits}`;
}
